import React from "react";
import { Link } from "react-router-dom";
import { MiniLogoSQ, LeftVector, RightVector } from "../../assets";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightToBracket,
  faEnvelope,
  faChevronLeft,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import AuthInput from "../../components/ui/AuthInput/AuthInput";
import { useLogin } from "../../hooks/useLogin";
import "./LoginPage.css";

const LoginPage = () => {
  const [typeEffect] = useTypewriter({
    words: ["Bienvenue de nouveau!"],
    loop: true,
    typeSpeed: 50,
    delaySpeed: 2000,
  });

  const { formData, loading, loginError, handleChange, handleLogin } =
    useLogin();



  return (
    <div className="login-page">
      {/* Back link */}
      <div className="back-link">
        <Link to="/" style={{ color: "#EF4346", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faChevronLeft} /> Retour
        </Link>
      </div>

      {/* Background vectors */}
      <img src={LeftVector} alt="left" className="vibrate-1 leftImageStyle" />
      <img
        src={RightVector}
        alt="Right"
        className="vibrate-2 rightImageStyle"
      />

      {/* Content */}
      <div className="login-content">
        <img src={MiniLogoSQ} alt="SmartQuest Logo" className="logo_reg" />
        <h2 className="title">Connexion</h2>

        <h1 className="main-title">
          {typeEffect}
          <Cursor cursorStyle="|" />
        </h1>

        {loginError && <div className="error-message">{loginError}</div>}

        <form className="login-form" onSubmit={(e) => e.preventDefault()}>
          {/* Email */}
          <div className="col-md-12">
            <AuthInput
              label="Email"
              name="email"
              placeholder="Votre Email"
              icon={faEnvelope}
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Password */}
          <div className="col-md-12">
            <AuthInput
              label="Mot de passe"
              name="password"
              type="password"
              placeholder="********"
              icon={faLock}
              value={formData.password}
              onChange={handleChange}
            />
          </div>

          {/* Forgot password */}
          <div className="mt-3 d-flex justify-content-center">
            <Link
              to="/forgetpwd"
              style={{ color: "#4D6466", textDecoration: "none" }}
            >
              Mot de passe oublié
            </Link>
          </div>

          {/* Submit button */}
          <div className="d-flex justify-content-center align-items_center mt-3">
            <button
              type="button"
              className="login-btn"
              onClick={handleLogin}
              disabled={loading}
            >
              <FontAwesomeIcon icon={faRightToBracket} className="me-2" />
              {loading ? "Connexion..." : "Connexion"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
